import { initializeApp } from "firebase/app"
import {
  Auth,
  browserPopupRedirectResolver,
  initializeAuth,
  inMemoryPersistence,
} from "firebase/auth"

const isServer = typeof window === "undefined"

/* eslint-disable */
export const firebaseConfig = process.env.NEXT_PUBLIC_FIREBASE_CONFIG
  ? JSON.parse(process.env.NEXT_PUBLIC_FIREBASE_CONFIG)
  : {
    apiKey: "AIzaSyCwOf3LsawEUUK5gRgeRGuQC52l_CxhWK0",
    authDomain: "cosine.wtf",
    projectId: "cosine-ai-staging",
    storageBucket: "cosine-ai-staging.appspot.com",
    messagingSenderId: "415635649632",
    appId: "1:415635649632:web:536a2895b468486750ff05"
  }

  /* eslint-enable */
export const app = initializeApp(firebaseConfig)

//SSR hack to get it to play nice
export const auth = isServer
  ? (undefined as unknown as Auth)
  : initializeAuth(app, {
      persistence: inMemoryPersistence,
      popupRedirectResolver: browserPopupRedirectResolver,
    })
